import React, { useState } from "react";
import {
  FiHome,
  FiCalendar,
  FiUsers,
  FiTag,
  FiBox,
  FiShoppingCart,
  FiUser,
  FiStar,
  FiMenu,
  FiChevronDown,
  FiChevronUp,
  FiTrendingUp,
  FiPrinter,
} from "react-icons/fi";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

const AdminSidebar = ({ open, toggleSidebar }) => {
  const [productOpen, setProductOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [orderOpen, setOrderOpen] = useState(false);

  const { adminRole, adminPermissions } = useSelector(
    (state) => state.adminAuth,
  );
  const can = (perm) =>
    adminRole === "super_admin" || adminPermissions?.includes(perm);

  const toggleProduct = () => {
    setProductOpen(!productOpen);
    setCategoryOpen(false);
    setOrderOpen(false);
  };
  const toggleCategory = () => {
    setCategoryOpen(!categoryOpen);
    setProductOpen(false);
    setOrderOpen(false);
  };
  const toggleOrder = () => {
    setOrderOpen(!orderOpen);
    setProductOpen(false);
    setCategoryOpen(false);
  };

  return (
    <>
      <nav className={`ad-sidebar ${open ? "open" : ""}`}>
        <div className="ad-logo">
          <img src="/logo.png" alt="Salon Admin" />
          <span className="sidebar-title">Admin Panel</span>
        </div>

        {/* Scrollable Sidebar Content */}
        <div className="sidebar-content">
          <ul className="nav flex-column">
            {can("dashboard.view") && (
              <li className="nav-item">
                <NavLink to="/admin" end className="nav-link">
                  <FiHome className="nav-icon" />
                  <span className="nav-text">Dashboard</span>
                </NavLink>
              </li>
            )}

            {can("bookings.view") && (
              <li className="nav-item">
                <NavLink to="/admin/bookings" className="nav-link">
                  <FiCalendar className="nav-icon" />
                  <span className="nav-text">Bookings</span>
                </NavLink>
              </li>
            )}

            {can("enquiries.view") && (
              <li className="nav-item">
                <NavLink to="/admin/enquiries" className="nav-link">
                  <FiTag className="nav-icon" />
                  <span className="nav-text">Enquiries</span>
                </NavLink>
              </li>
            )}

            {/* Customers  */}
            {can("customers.view") && (
              <li className="nav-item">
                <NavLink to="/admin/customers" className="nav-link">
                  <FiUsers className="nav-icon" />
                  <span className="nav-text">Customers</span>
                </NavLink>
              </li>
            )}

            {can("roles.view") && (
              <li className="nav-item">
                <NavLink to="/admin/role" className="nav-link">
                  <FiUsers className="nav-icon" />
                  <span className="nav-text">Role Management</span>
                </NavLink>
              </li>
            )}

            {can("admins.view") && (
              <li className="nav-item">
                <NavLink to="/admin/user-management" className="nav-link">
                  <FiUsers className="nav-icon" />
                  <span className="nav-text">Users Management</span>
                </NavLink>
              </li>
            )}

            {/* Product Dropdown */}
            {(can("products.view") || can("products.create")) && (
              <li className="nav-item dropdown-parent">
                <button
                  className="nav-link dropdown-btn"
                  onClick={toggleProduct}
                >
                  <span className="nav-left">
                    <FiBox className="nav-icon" />
                    <span className="nav-text">Product</span>
                  </span>
                  {productOpen ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                {productOpen && (
                  <ul className="submenu">
                    {can("products.view") && (
                      <li>
                        <NavLink
                          to="/admin/products"
                          className="nav-link submenu-link"
                        >
                          Product List
                        </NavLink>
                      </li>
                    )}
                    {can("products.create") && (
                      <li>
                        <NavLink
                          to="/admin/products/create"
                          className="nav-link submenu-link"
                        >
                          Add Product
                        </NavLink>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}

            {/* Category Dropdown */}
            {(can("categories.view") || can("categories.create")) && (
              <li className="nav-item dropdown-parent">
                <button
                  className="nav-link dropdown-btn"
                  onClick={toggleCategory}
                >
                  <span className="nav-left">
                    <FiTag className="nav-icon" />
                    <span className="nav-text">Categories</span>
                  </span>
                  {categoryOpen ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                {categoryOpen && (
                  <ul className="submenu">
                    {can("categories.view") && (
                      <li>
                        <NavLink
                          to="/admin/categories"
                          className="nav-link submenu-link"
                        >
                          Category List
                        </NavLink>
                      </li>
                    )}
                    {can("categories.create") && (
                      <li>
                        <NavLink
                          to="/admin/categories/create"
                          className="nav-link submenu-link"
                        >
                          Add Category
                        </NavLink>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}

            {/* Orders Dropdown */}
            {can("orders.view") && (
              <li className="nav-item dropdown-parent">
                <button className="nav-link dropdown-btn" onClick={toggleOrder}>
                  <span className="nav-left">
                    <FiShoppingCart className="nav-icon" />
                    <span className="nav-text">Orders</span>
                  </span>
                  {orderOpen ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                {orderOpen && (
                  <ul className="submenu">
                    {can("orders.update_status") && (
                      <li>
                        <NavLink
                          to="/admin/orders"
                          className="nav-link submenu-link"
                        >
                          Order List
                        </NavLink>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}

            {/* Product Reviews */}
            {can("product_reviews.view") && (
              <li className="nav-item">
                <NavLink to="/admin/reviews" className="nav-link">
                  <FiStar className="nav-icon" />
                  <span className="nav-text">Reviews</span>
                </NavLink>
              </li>
            )}

            {/* Reports */}
            {can("reports.view") && (
              <li className="nav-item">
                <NavLink to="/admin/reports" className="nav-link">
                  <FiTrendingUp className="nav-icon" />
                  <span className="nav-text">Reports</span>
                </NavLink>
              </li>
            )}

            {/* Invoices */}
            {can("invoices.view") && (
              <li className="nav-item">
                <NavLink to="/admin/invoices" className="nav-link">
                  <FiPrinter className="nav-icon" />
                  <span className="nav-text">Invoices</span>
                </NavLink>
              </li>
            )}
            {adminRole === "super_admin" && (
              <li className="nav-item">
                <NavLink to="/admin/profile" className="nav-link">
                  <FiUser className="nav-icon" />
                  <span className="nav-text">Profile</span>
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </nav>

      {/* Mobile Toggle Button */}
      <button
        className="ad-sidebar-toggle btn btn-light d-lg-none"
        onClick={toggleSidebar}
      >
        <FiMenu size={24} />
      </button>
    </>
  );
};

export default AdminSidebar;
